import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Tab, Tabs } from '@blueprintjs/core';
import { Tooltip2, Classes } from '@blueprintjs/popover2';
import EnhancedSingleSelect from '../../../common/EnhancedSingleSelect';

import CollocByCorpus from './CollocByCorpus.js';
import { H2 } from '@blueprintjs/core';

class Colloc extends React.PureComponent {

  state = {
    //selectedTabId: Object.keys(this.props.stats.byCorpus)[0],  // select first corpus by default
    selectedTabId: "Global" 
  }

  handleTabChange = (navbarTabId) => {
    this.setState({ selectedTabId: navbarTabId });
    //  this trick is to cope with the react-apex-chart show problem
    window.dispatchEvent(new Event('resize'));
  }

  render() {
    const { stats, t, subCorpora, queryHistory, onSelectResult } = this.props;

    const tabs = [];
    const statGlobal = <CollocByCorpus
                            name='global' 
                            collocStats={stats.colloc['__global__']} 
                            relStats={stats.rel['__global__']} 
                            spec={stats.spec}
                            performSearch={this.props.performSearch}
                        />;
    const tab = <Tab key='Global' id='Global' title={t('global')} panel={statGlobal} />;
    tabs.push(tab);

    const navSelect=  
      <div style={{display:'flex'}}>
        <EnhancedSingleSelect
            label={t('query')}
            name='query'  // name is also used to make the input's `id`
            options={queryHistory}
            value={queryHistory[0]}
            onChange={onSelectResult}
        />
      </div>;

    // generate the indidual stat pages (sub-corpus or partition) if necessary
    for (var i=0;i<subCorpora.length;i++) {
      const subCorpus=subCorpora[i];
      let title=subCorpus;
      let displayName=false;
      if (subCorpora.length>16) {
        displayName=true;
        title=" "+(i+1).toString();
        title=title.slice(-2);
      }
      const stat = <CollocByCorpus
                      name={subCorpus}
                      displayName={displayName}
                      collocStats={stats.colloc[subCorpus]} 
                      relStats={stats.rel[subCorpus]} 
                      spec={stats.spec} 
                      performSearch={this.props.performSearch}
                  />;
      const tab = <Tab key={subCorpus} id={subCorpus} title={title} panel={stat} >
                    {displayName && <Tooltip2 content={subCorpus} className={Classes.TOOLTIP2_INDICATOR} placement="bottom" >…</Tooltip2>}
                  </Tab>;
      tabs.push(tab);
    }

    return (
      <>
        {navSelect}
        <H2>{t('collocCollig')}</H2>
        <Tabs onChange={this.handleTabChange} selectedTabId={this.state.selectedTabId} renderActiveTabPanelOnly={true}>
          {tabs}
        </Tabs>
      </>
    );
  }
}

Colloc.propTypes = {
  stats: PropTypes.object,
  subCorpora: PropTypes.array,
  performSearch: PropTypes.func,
  queryHistory: PropTypes.array,
  onSelectResult : PropTypes.func,
};

export default withTranslation()(Colloc);
